import React from 'react'
import { Link } from 'react-router-dom'
import './breadcrumbs.css'

const Breadcrumbs = ({ items, className = '' }) => {
  if (!items || items.length === 0) return null

  return (
    <nav 
      className={`breadcrumbs ${className}`} 
      aria-label="Breadcrumb navigation"
    >
      <ol className="breadcrumbs-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          
          return (
            <li key={item.path || index} className="breadcrumb-item">
              {!isLast && item.path ? (
                <Link 
                  to={item.path}
                  className="breadcrumb-link"
                  aria-label={`Go to ${item.label}`}
                >
                  {item.label}
                </Link>
              ) : (
                <span 
                  className="breadcrumb-current"
                  aria-current={isLast ? "page" : undefined}
                >
                  {item.label}
                </span>
              )}
              {!isLast && (
                <svg 
                  className="breadcrumb-separator"
                  width="16" 
                  height="16" 
                  viewBox="0 0 16 16" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs